// Load all images in the avatars folder
const avatarImages = require.context('@/assets/dummy-avatars', false, /\.(jpe?g|png|webp)$/);

// Build a set of available filenames
const availableAvatars = new Set(
  avatarImages.keys().map((file) => file.replace('./', ''))
);

export function getAvatar(firstName, middleName, lastName) {
  let imgName = [firstName, middleName, lastName]
    .filter(Boolean).join('-').trim().toLowerCase();
  return availableAvatars.has(`${imgName}.jpg`) ? avatarImages(`./${imgName}.jpg`) : null;
}